import { AuditMetadata, Visibility } from '@fullstory/proto/fs/gcloud/dstore/protoauditstore';
import { Metadata } from '@fullstory/proto/fs/services/dx-objects';
import { Timestamp, int64 } from '@fullstory/proto/google/protobuf';

export const DEFAULT_AUDIT_METADATA: AuditMetadata = {
  lastUpdated: Timestamp.now(),
  lastUpdatedBy: 'FullStory',
  created: Timestamp.now(),
  createdBy: 'FullStory',
  archived: false,
  visibility: Visibility.PUBLIC,
  version: int64.zero,
  sequentialVersion: int64.zero,
};

export const PRIVATE_AUDIT_METADATA: AuditMetadata = {
  lastUpdated: Timestamp.now(),
  lastUpdatedBy: 'FullStory',
  created: Timestamp.now(),
  createdBy: 'FullStory',
  archived: false,
  visibility: Visibility.PRIVATE,
  version: int64.zero,
  sequentialVersion: int64.zero,
};

export const DEFAULT_DASHBOARD_CARD_METADATA: Metadata = {
  updatedAt: Timestamp.now(),
  updatedBy: 'FullStory',
  createdAt: Timestamp.now(),
  createdBy: 'FullStory',
  version: 0,
};

export const mockAuditMetadata = (metadata?: Partial<AuditMetadata>): AuditMetadata => ({
  ...DEFAULT_AUDIT_METADATA,
  ...metadata,
});

export const mockDashboardCardMetadata = (metadata?: Partial<Metadata>): Metadata => ({
  ...DEFAULT_DASHBOARD_CARD_METADATA,
  ...metadata,
});
